import { Avatar } from "@mui/material";
import React from "react";
import { getUserInitials } from "../../../services/helpers/commonHelpers";
import { useTranslation } from "react-i18next";

interface UserMenuItemProps {
  name: string;
  onSettingsOpen: () => void;
}

const UserMenuItem = (props: UserMenuItemProps) => {
  const { name, onSettingsOpen } = props;

  const { t } = useTranslation();

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    onSettingsOpen();
  };

  return (
    <div className="dui-user-menu-item" onClick={handleClick}>
      <div className="dui-user-menu-item-icon">
        <Avatar>{getUserInitials(name)}</Avatar>
      </div>
      <div className="dui-user-menu-item-content">
        <div className="dui-user-menu-item-title">{t("profile")}</div>
        <div className="dui-user-menu-item-name">{name}</div>
      </div>
    </div>
  );
};

export default UserMenuItem;
